import { render, staticRenderFns } from "./attachment.vue?vue&type=template&id=4d0f450d&scoped=true"
import script from "./attachment.vue?vue&type=script&lang=js"
export * from "./attachment.vue?vue&type=script&lang=js"
import style0 from "./attachment.vue?vue&type=style&index=0&id=4d0f450d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0f450d",
  null
  
)

export default component.exports